module.exports = __webpack_public_path__ + "static/brand-logo-profhilo-9752f2b6c30ba37ef5edbf4a4f5f64a7.svg";